import { Instagram, Linkedin } from "lucide-react";

const DP = "https://www.deltapictures.it";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#121212] text-white py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/[0.08]">
          <div className="md:col-span-5">
            <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40 mb-3">
              Un progetto di
            </div>
            <a
              href={DP}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-delta-logo"
              aria-label="Delta Pictures — vai al sito deltapictures.it"
              className="inline-flex items-center gap-3 group"
            >
              <img
                src={(process.env.PUBLIC_URL || "") + "/delta-pictures-mark.png"}
                alt="Delta Pictures"
                className="h-9 md:h-10 w-auto"
              />
              <span className="font-display text-xl md:text-2xl font-semibold text-white tracking-tight group-hover:text-[#FF6B1A] transition-colors">
                Delta Pictures
              </span>
            </a>
            <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-white/40 mt-2">
              Gruppo editoriale · Agenzia di comunicazione · 2004 / {new Date().getFullYear()}
            </p>
            <p className="text-white/55 text-sm leading-relaxed mt-4 max-w-md">
              Modo Motori è il canale automotive di Delta Pictures su YouTube e fa parte dell'universo Modo: un ecosistema di format e contenuti pensati per le piattaforme digitali.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.instagram.com/gruppo_delta_pictures"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram Delta Pictures"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white hover:text-black hover:border-white transition-all duration-300"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://www.linkedin.com/company/delta-pictures"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="LinkedIn Delta Pictures"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/70 hover:bg-white hover:text-black hover:border-white transition-all duration-300"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40 mb-4">
              Sedi
            </div>
            <address className="not-italic text-white/70 text-sm leading-relaxed">
              <span className="text-white font-medium">Biella</span><br />
              Via Boglietti, 2 · 13900 Biella (IT)
            </address>
            <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40 mt-7 mb-4">
              Contatti
            </div>
            <ul className="space-y-2.5 text-white/70 text-sm">
              <li>
                <a href="mailto:info@deltapictures.it" className="hover:text-[#FF6B1A] transition-colors">
                  info@deltapictures.it
                </a>
              </li>
              <li>
                <a href="tel:+390152471679" className="hover:text-[#FF6B1A] transition-colors">
                  +39 015 247 16 79
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/40 mb-4">
              Legale
            </div>
            <ul className="space-y-2.5 text-white/70 text-sm">
              <li>
                <a href={`${DP}/disclaimer/`} target="_blank" rel="noreferrer noopener" className="hover:text-[#FF6B1A] transition-colors">
                  Disclaimer
                </a>
              </li>
              <li>
                <a href={`${DP}/privacy-policy/`} target="_blank" rel="noreferrer noopener" className="hover:text-[#FF6B1A] transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href={`${DP}/cookie-policy/`} target="_blank" rel="noreferrer noopener" className="hover:text-[#FF6B1A] transition-colors">
                  Cookie Policy
                </a>
              </li>
              <li>
                <a href={`${DP}/codice-etico/`} target="_blank" rel="noreferrer noopener" className="hover:text-[#FF6B1A] transition-colors">
                  Codice Etico
                </a>
              </li>
              <li>
                <button
                  type="button"
                  data-testid="footer-change-consent"
                  className="hover:text-[#FF6B1A] transition-colors cursor-pointer"
                  onClick={() => {
                    if (typeof window.__tcfapi === "function") {
                      window.__tcfapi("displayConsentUi", 2, () => {});
                    } else {
                      window.location.href = "/cookie";
                    }
                  }}
                >
                  Gestione Consenso Cookie
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 font-mono text-[10px] tracking-[0.14em] uppercase text-white/35 leading-relaxed">
          © Delta Pictures S.r.l. – Cap. Soc. € 50.000 i.v. – P. IVA: 02154000026 – n. R.E.A. BI 181760
        </div>
      </div>
    </footer>
  );
}
